import { useCallback, useState } from "react";
import { FormikHelpers } from "formik";
import { toast } from "@jsq/ds/core";
import { useAddGroupMembershipMutation } from "~/graphql/supergraphHooks";
import { toGlobalId } from "~/utils/graphql-helpers";

export type FormValues = { roles?: string[] };

export const useAddRoleForm = ({ userIds }: { userIds: string[] }) => {
  const [showModal, setShowModal] = useState(false);
  const [addGroupMembership] = useAddGroupMembershipMutation();

  const onHide = useCallback(() => {
    setShowModal(false);
  }, []);

  const openModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const addCanopyRole = useCallback(
    async (values: FormValues, { resetForm }: FormikHelpers<FormValues>) => {
      try {
        const response = await addGroupMembership({
          variables: {
            input: {
              arenaId: toGlobalId("ArenaObjectType", 0),
              groupIds: values?.roles ?? [],
              userIds,
            },
          },
          refetchQueries: ["GetCcToolsUser"],
        });
        const data = response.data?.addGroupMembership;

        if (data?.__typename === "AddGroupMembershipResult") {
          onHide();
          toast.success("Successfully updated Canopy Roles");
          resetForm();
        } else if (data?.__typename === "MutationErrorResponse") {
          toast.error(data.message);
        } else {
          toast.error("There was an error with the operation");
        }
      } catch {
        toast.error("There was an error with the operation");
      }
    },
    [addGroupMembership, userIds, onHide],
  );

  const initialValues: FormValues = { roles: [] };

  return { initialValues, onHide, openModal, showModal, addCanopyRole };
};
